import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import {
  getBrandRole,
  postStoreUsersStoreConfig,
} from "../../../services/StoreUsers/PostStoreUsers";
import SuccessModal from "../../SuccessModal";
import {
  getBrandNotification,
  postMapStoreNotification,
} from "../../../services/StoreNotification/StoreNotification";

const StoreNotificationAddModal = ({
  storeNotificationAddModalVisible,
  setStoreNotificationAddModalVisible,
  sendDataToStoreConfig,
  brandId,
  storeUserList,
  storeId,
}) => {
  const OrderStatus = storeUserList;

  const ordersData = OrderStatus.filter(
    (item) => item.mapped === false && item.role !== "ROLE_WAREHOUSE",
  );

  const [selectedStatus, setSelectedStatus] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [notificationTemplateList, setNotificationTemplateList] = useState([]);
  const [submitButtonPress, setSubmitButtonPress] = useState(false);

  const handleStatusToggle = (status) => {
    const updatedStatus = [status];
    setSelectedStatus(updatedStatus);
  };
  const fetchNotificationTemplate = () => {
    const data = {
      brandId: brandId,
    };
    getBrandNotification(data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const filteredData = Res.filter((item) => item.status === true);
          const data = filteredData.map((item) => ({
            label: item.templateType.templateType,
            value: item.id,
          }));
          setNotificationTemplateList(data);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchNotificationTemplate();
  }, []);

  const handleDataSubmit = () => {
    if (!submitButtonPress) {
    setSubmitButtonPress(true);

    const updatedData = {
      store: {
        id: storeId,
      },
      brandNotificationTemplate: {
        id: selectedStatus[0],
      },
    };
    postMapStoreNotification(updatedData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            const message = Res.message;
            const status = Res.status;
            setStoreNotificationAddModalVisible(false);
            sendDataToStoreConfig({
              success: true,
            });
            if (status === true) {
              setModalVisible(true);
              setModalStatus("success");
              setModalText(message);
              setSubmitButtonPress(false);
            } else {
              setModalVisible(true);
              setModalStatus("not Success");
              setModalText(message);
              setSubmitButtonPress(false);
            }
            setSelectedStatus([]);
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
    }
  };

  const handleModalClose = () => {
    setStoreNotificationAddModalVisible(false);
    setSelectedStatus([]);
    setSubmitButtonPress(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={storeNotificationAddModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!storeNotificationAddModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-1 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <img
                style={{
                  height: 45,
                  width: 45,
                  // alignSelf: 'center',
                }}
                src={"images/plus.png"}
              />

              <p className=" text-4xl text-primary-50 font-semibold">
                ADD TEMPLATE
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            <div
              className="h-20rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
              <div className="mx-4">
                {notificationTemplateList?.length > 0 ? (
                  notificationTemplateList?.map((item) => (
                    <div
                      key={item.id}
                      className="flex flex-1 justify-content-between my-1"
                    >
                      <p className="text-xl font-medium">
                        {item.label.substring(0, 50)}
                        {item.label.length > 50 ? "..." : ""}
                      </p>
                      <div>
                        <Checkbox
                          checked={selectedStatus.includes(item.value)}
                          size="20" // Increased size
                          color={
                            selectedStatus.includes(item.value)
                              ? "#00A3FF"
                              : "#C1C9D3"
                          }
                          onClick={() => handleStatusToggle(item.value)}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <div>
                    <p className="text-xl font-medium">No Store User Found</p>
                  </div>
                )}
              </div>
            </div>

            <Button
              onClick={handleDataSubmit}
              className="mt-1 mb-3 mx-4 border-round-xl "
              disabled={selectedStatus?.length <= 0 || submitButtonPress}
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                ADD
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
};

export default StoreNotificationAddModal;
